<template>
    <div :id="this.$route.name">
        <Card back>
            <template v-slot:header>
                <h4 class="d-inline">سرفصل های حسابداری</h4>
                <hr />
            </template>

            <template v-slot:content>

                <section>
                    <div>حقوق و مزایا (بدهکار)</div>
                    <div class="row mt-2">
                        <div class="col-md-3 col-12">
                            <small id="LblSalaryBasic">حقوق پایه ماهانه</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.SalaryBasic.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'SalaryBasic'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblChild">حق اولاد</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Child.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Child'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblHome">حق مسکن</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Home.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Home'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblAddWork">اضافه کاری</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.AddWork.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'AddWork'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBone">حق بن</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Bone.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Bone'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblSanavat">پایه سنوات</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Sanavat.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Sanavat'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblSkill">مهارت</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Skill.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Skill'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblResponsibility">حق مسئولیت</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Responsibility.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Responsibility'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblEducation">حق تحصیلات</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Education.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Education'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblAmazing">فوق العاده</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Amazing.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Amazing'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblHageJazb">حق جذب</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.HageJazb.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'HageJazb'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblHageShift">حق شیفت</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.HageShift.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'HageShift'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblHardWork">سختی کار</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.HardWork.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'HardWork'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblFood">حق غذا</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Food.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Food'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblCashier">صندوقدار</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Cashier.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Cashier'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblTransportation">ایاب و ذهاب</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Transportation.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Transportation'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblRewards">پاداش</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Rewards.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Rewards'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblEidi">عیدی</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Eidi.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Eidi'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblYearSanavat">سنوات پایان سال</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.YearSanavat.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'YearSanavat'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblMisson">ماموریت</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.Misson.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'Misson'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblOtherBenefits">سایر مزایا</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.OtherBenefits.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'OtherBenefits'" :ClassProps="'required'"> </SearchableCombo>
                        </div>

                        <div class="col-md-3 col-12">
                            <small id="LblBimeTakmily">بیمه تکمیلی</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.BimeTakmily.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'BimeTakmily'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBimeSahmeKarfarma">بیمه سهم کارفرما</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.BimeSahmeKarfarma.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'BimeSahmeKarfarma'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBimeBikary">بیمه بیکاری</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.BimeBikary.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'BimeBikary'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBimeBikary">حق تاهل</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.HageTaahol.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'HageTaahol'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                    </div>
                </section>

                <hr>

                <section>
                    <div>کسورات (بستانکار)</div>
                    <div class="row mt-2">
                        <div class="col-md-3 col-12">
                            <small id="LblMissPerformanceTarafHesab">کسری کار</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.MissPerformanceTarafHesab.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'MissPerformanceTarafHesab'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblSosTarafHesab">مساعده</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.SosTarafHesab.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'SosTarafHesab'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblFacilityTarafHesab">تسهیلات</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.FacilityTarafHesab.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'FacilityTarafHesab'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblMissOtherTarafHesab">سایر کسورات</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.MissOtherTarafHesab.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'MissOtherTarafHesab'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblTaxTarafHesab">مالیات</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.TaxTarafHesab.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'TaxTarafHesab'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBimeKarmandTarafHesab">بیمه سهم کارمند</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.BimeKarmandTarafHesab.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'BimeKarmandTarafHesab'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBimeTakmilyTarafHesab">بیمه تکمیلی</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.BimeTakmilyTarafHesab.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'BimeTakmilyTarafHesab'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBimeSahmeKarfarmaTarafHesab">بیمه سهم کارفرما</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0"
                                @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.BimeSahmeKarfarmaTarafHesab.SarfaslId"
                                :rownumintable="3" :action="'SarfaslSalary/GetCombo'" :method="'GET'"
                                :idinput="'KasreSalary'" :keyItem="'BimeSahmeKarfarmaTarafHesab'" :ClassProps="'required'">
                            </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblBimeBikaryTarafHesab">بیمه بیکاری</small>
                            <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetComboResult"
                                :defaultvalue="TblSarfaslSanadSalary.BimeBikaryTarafHesab.SarfaslId" :rownumintable="3"
                                :action="'SarfaslSalary/GetCombo'" :method="'GET'" :idinput="'KasreSalary'"
                                :keyItem="'BimeBikaryTarafHesab'" :ClassProps="'required'"> </SearchableCombo>
                        </div>
                    </div>
                </section>

                <hr />
                <button class="btn btn-success" @click.prevent="SaveDeta()">ثبت اطلاعات</button>

            </template>
        </Card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Modal from '@/pages/Modal/Modal.vue';
import Tab from '@/components/Tab/Tab.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
    data() {
        return {
            TblSarfaslSanadSalary: [],

        }
    },
    components: { Card, SearchableCombo, Modal, Tab, BnpGrid },
    methods: {

        GetComboResult(data) {
            if (data.id != null) {
                let obj = Reflect.get(this.TblSarfaslSanadSalary,  data.key)
                Reflect.set(obj, 'SarfaslId', data.id)
            }
        },

        checkResponse(response, successFunc, failFunc) {
            if (response.IsSuccess == true) {
                if(successFunc != undefined){
                    successFunc()
                }
                if (response.Message != null & response.Message != '') {
                    this.$mySweetDefaultTost('', response.Message, 'success', 3000)
                }
            } else {
                if(failFunc != undefined){
                    failFunc()
                }
                if (response.Message != null & response.Message != '') {
                    this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                }
            }
        },

        SaveDeta() {
            if (this.$ValidForm(this.$route.name)) {
                this.$PostData({ Action: 'SarfaslSalary', Method: 'Put', ArryfildValue: this.TblSarfaslSanadSalary })
                    .then((response) => {
                    this.checkResponse(response, () => this.$SetLog(this.TblSarfaslSanadSalary, 0))
                }).catch((err) => {this.$mySweetDefaultTost('', 'خطای سمت سرور', 'error', 3000) })
            }
        }

    },
    mounted() {
        let workshopId = this.$route.params.workShopId;
        this.$PostData({ Action: 'SarfaslSalary/' + workshopId, Method: 'Get' }).then((response) => {
            this.checkResponse(response, () => {
                this.TblSarfaslSanadSalary = response.Data
                this.$store.state.OldDataForLog = JSON.stringify(this.TblSarfaslSanadSalary)
            })
        }).catch((err) => { this.$mySweetDefaultTost('', 'خطای سمت سرور', 'error', 3000) })
    }
}
</script>
